import React from 'react';

import { InputAdornment } from '@mui/material';

import { CircularProgress } from '../../../CircularProgress';

import useStyles from './Preloader.style';

/**
 * Preloader - компонент для отображения индикатора загрузки в поле ввода.
 *
 * @returns {JSX.Element} Возвращает JSX-элемент представляющий компонент Preloader.
 */

export const Preloader = () => {
  const { classes } = useStyles();

  return (
    <InputAdornment
      className={classes.preloader}
      position="end"
      sx={{ height: 0 }}
    >
      <CircularProgress size={18} />
    </InputAdornment>
  );
};
